export default __webpack_public_path__ + "static/media/bg-video.3fc77bc4.mp4";